<section class="sign-container sign-up-referral-code-container">
	<img class="sign-in-background" src="../../../assets/img/{{themeService.theme}}/zp-lg-background.png" alt=""
		*ngIf="themeService.theme != 'weightmans'">
	<section class="navbar-brand">
		<img src="../../assets/img/{{themeService.theme}}/{{themeService.theme == 'bluecoat' ? 'main-logo' : 'scd-logo'}}.png" alt="Company Logo" width="125px"
			[ngClass]="{'img-theme-nav-bar': themeService.theme == 'life-file'}">
	</section>
	<section class="container" [ngClass]="{'bluecoat-login-card': themeService.theme == 'bluecoat'}">
		<form [formGroup]="signUpRefCodeForm" (ngSubmit)="onSubmit()">
			<h1 class="serif-title" [ngClass]="{'nwr-color-title': themeService && themeService.theme == 'NWRTheme'}">Create Your Account</h1>
			<section class="sign-get-info">
				<input type="text" formControlName="refCode" class="form-control get-referral-code"
					placeholder="Your referral code">
				<div *ngIf="refCodeFail">
					<div>Login Failure</div>
				</div>
				<div class="forgot-info">What is my referral code?</div>
				<input type="submit" class="form-control btn btn-primary primary-default-btn" value="Continue" [ngClass]="{'nwr-theme-input': themeService.theme == 'NWRTheme'}">
				<div *ngIf="submitted && f.refCode.errors" class="invalid-feedback">
					<div *ngIf="f.refCode.errors.required">Code is required</div>
				</div>
				<!-- <div class="sign-account" [routerLink]="['/sign-in']">Already have an account? Sign In</div> -->
				<div class="sign-account sign-account-mobile" [routerLink]="['/sign-in']">Already have an account? Sign
					In
				</div>
			</section>
		</form>
	</section>
</section>
<app-footer></app-footer>